import React from "react";
import { numberWithCommas } from "util/common";
import styles from "./style.module.scss";

const PlanProgressBar = ({
  label,
  sublabel,
  used = 0,
  max,
  showValues = true,
  valueFormatter,
  headerAction,
  footer,
  className,
}) => {
  const safeUsed = Number.isFinite(Number(used)) ? Number(used) : 0;
  const hasMax = max != null && Number(max) > 0;
  const safeMax = hasMax ? Number(max) : 0;
  const pct = hasMax
    ? Math.min(100, Math.round((safeUsed / safeMax) * 100))
    : 0;
  const isOver = hasMax && safeUsed > safeMax;
  const format = valueFormatter || ((value) => numberWithCommas(value));
  const usageRatio = hasMax
    ? `${format(safeUsed)} / ${format(safeMax)}`
    : format(safeUsed);

  return (
    <div className={`${styles.quotaProgressBlock} ${className || ""}`}>
      <div className={styles.quotaProgressTopRow}>
        <div className={styles.quotaProgressLabels}>
          <div className={styles.quotaProgressLabelRow}>
            {label ? <h5 className={styles.quotaProgressTitle}>{label}</h5> : null}
            {headerAction ? (
              <div className={styles.quotaProgressHeaderAction}>{headerAction}</div>
            ) : null}
          </div>
          {sublabel ? (
            <span className={styles.quotaProgressSub}>{sublabel}</span>
          ) : null}
        </div>
        {showValues ? (
          <span className={styles.usageValue}>{usageRatio}</span>
        ) : null}
      </div>
      {showValues && hasMax ? (
        <div className={styles.quotaProgressPctRow}>
          <span className={styles.usagePct}>{pct}%</span>
        </div>
      ) : null}
      {hasMax ? (
        <div
          className={styles.progressTrack}
          role="progressbar"
          aria-valuenow={safeUsed}
          aria-valuemin={0}
          aria-valuemax={safeMax}
        >
          <div
            className={`${styles.progressFill} ${isOver ? styles.progressFillOver : ""}`}
            style={{ width: `${Math.min(100, (safeUsed / safeMax) * 100)}%` }}
          />
        </div>
      ) : null}
      {footer ? <div className={styles.quotaProgressFooter}>{footer}</div> : null}
    </div>
  );
};

export default PlanProgressBar;
